import { render } from "./AppView.vue?vue&type=template&id=56172338&scoped=true"
import script from "./AppView.vue?vue&type=script&lang=js"
export * from "./AppView.vue?vue&type=script&lang=js"

import exportComponent from "/mnt/gasoil_files/gasoil/docker/boletiland/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56172338"]])

export default __exports__